import React, { useContext } from 'react';

export const AppContext = React.createContext({});
export const AppProvider = AppContext.Provider;
export const AppConsumer = AppContext.Consumer;

export const withApp = Component => {

    class AppComponent extends React.Component {
        constructor(props) {
            super(props);
            this.comp = null;
        }

        componentDidMount() {
            if (typeof(this.props.onRef) == 'function')
                this.props.onRef(this.getChildComponent());
        }

        getChildComponent() {

            if (this.comp && typeof(this.comp.getChildComponent) == 'function')
                return this.comp.getChildComponent();

            return this.comp;

        }

        render() {
            return (
                <AppConsumer>
                    {app => (<Component {...this.props} ref={el => { this.comp = el; }} app={app}/>)}
                </AppConsumer>
            );
        }
    }

    return AppComponent;

};

AppContext.displayName = 'AppContext';

export const useApp = () => useContext(AppContext);